var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortZa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort_za_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sort_za_svg__ds{fill:#fff}.sort_za_svg__dt{opacity:0}.sort_za_svg__du{fill:#f7f7f7}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sort_za_svg__du",
    d: "m366.83,313.19c-4.69-4.69-12.29-4.69-16.97,0l-32.91,32.91V54.92c0-6.63-5.37-12-12-12s-12,5.37-12,12v291.19l-32.92-32.92c-4.69-4.69-12.29-4.69-16.97,0s-4.69,12.28,0,16.97l53.4,53.4c.09.09.18.16.27.24.2.19.39.37.6.54.17.14.35.26.52.39.14.1.27.21.42.31.19.13.39.24.58.35.14.08.28.17.42.25.19.1.39.19.59.28.16.07.31.15.48.22.19.08.38.14.57.21.18.06.35.13.54.19.19.06.38.1.57.15.19.05.38.1.57.14.22.04.44.07.65.1.17.02.34.06.51.07.39.04.79.06,1.18.06h0s.01,0,.02,0c.39,0,.78-.02,1.17-.06.18-.02.36-.05.54-.08.21-.03.41-.05.62-.09.21-.04.41-.1.61-.15.18-.04.35-.08.53-.14.2-.06.39-.13.59-.21.17-.06.35-.12.52-.19.18-.08.36-.17.54-.25.18-.08.35-.16.53-.25s.34-.2.5-.3c.17-.1.34-.2.5-.31.19-.12.36-.26.54-.4.13-.1.27-.19.4-.3.31-.25.6-.52.89-.8l53.39-53.39c4.69-4.69,4.69-12.28,0-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort_za_svg__du",
    d: "m161.77,358.25h-60.27l-9.97,28.83h-31.87l54.42-151.54h35.34l54.42,151.54h-32.09l-9.97-28.83Zm-8.24-24.28l-21.9-63.31-21.9,63.31h43.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort_za_svg__du",
    d: "m115.26,168.66h68.07v25.58h-103.2v-23.41l67.64-102.33h-67.64v-25.58h103.2v23.41l-68.07,102.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "sort_za_svg__dt"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sort_za_svg__ds",
    x: 0.5,
    y: 0.5,
    width: 429,
    height: 429
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429,1v428H1V1h428m1-1H0v430h430V0h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortZa);
export default __webpack_public_path__ + "static/media/sort_za.14b48a2515f4f890f8852a36d08b13fc.svg";
export { ForwardRef as ReactComponent };